//Close the cookies pop-up
$(function () {
    $('.js-close-cookie').on('click', function () {
        $(this).parents('.cookies').slideUp();
    });
});